"use client";

export default function DefaultPage() {
  return <></>;
}
